export enum ProjectStatusEnum {
    WITHOUT_FOLLOW_UP = "WITHOUT_FOLLOW_UP	",
    POTENTIAL = "POTENTIAL",
    IN_PROGRESS = "IN_PROGRESS",
    FINALIZED = "FINALIZED",
}